import { Flex } from '@adobe/react-spectrum';
import LabeledValue from '../../../../CommonComponent/labeledValue';
import { StudentPaymentData } from '../../types';

const PersonalDetails: React.FC<{ studentData: StudentPaymentData }> = ({ studentData }) => {
  return (
    <Flex direction="row" wrap="wrap" marginTop="size-200" rowGap="size-200">
      <LabeledValue width="25%" label="Name" value={studentData.name} textAlign="center" />
      <LabeledValue width="25%" label="Admission Id" value={studentData.admissionId} textAlign="center" />
      <LabeledValue width="25%" label="Class" value={`${studentData.class} ${studentData.section}`} textAlign="center" />
      <LabeledValue width="25%" label="Email" value={studentData.email ?? 'N/A'} textAlign="center" />
      <LabeledValue width="25%" label="Contact No" value={studentData.contactNo ?? 'N/A'} textAlign="center" />
      <LabeledValue width="25%" label="Mother's Name" value={studentData.motherName ?? 'N/A'} textAlign="center" />
      <LabeledValue width="25%" label="Father's Name" value={studentData.fatherName ?? 'N/A'} textAlign="center" />
    </Flex>
  );
};

export default PersonalDetails;
